import { useEffect } from 'react';
import { Unlock } from 'lucide-react';
import useNavStore from '../../store/navStore';

/**
 * Bouton flottant « Débloquer l'accès » d'une thématique, pour un compte gratuit.
 * Prend la place du bouton « Feedback » (même coin) tant qu'il est affiché.
 */
export default function UnlockFab({ prix, onClick }) {
    const setFeedbackFabHidden = useNavStore(s => s.setFeedbackFabHidden);
    useEffect(() => {
        setFeedbackFabHidden(true);
        return () => setFeedbackFabHidden(false);
    }, [setFeedbackFabHidden]);

    return (
        <button type="button" className="unlock-fab" onClick={onClick} aria-label={`Débloquer l'accès complet${prix ? ` dès ${prix}` : ''}`}>
            <Unlock size={16} aria-hidden="true" />
            <span>Débloquer l’accès{prix && <span className="unlock-fab__prix"> · dès {prix}</span>}</span>
        </button>
    );
}
